import React from 'react';
import PropTypes from 'prop-types';

const ActionsMenuItem = ({
  isDisplayed,
  name,
  onSelect,
  parentClass,
  text,
  icon,
}) => {
  if (!isDisplayed) { return null; }

  return (
    <li
      className={`${parentClass}--${name} item`}
      name={name}
      onClick={() => onSelect(name)}
    >
      <span className={icon} />
      {text}
    </li>
  );
};

ActionsMenuItem.propTypes = {
  icon: PropTypes.string.isRequired,
  isDisplayed: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  parentClass: PropTypes.string,
  text: PropTypes.string.isRequired,
};

ActionsMenuItem.defaultProps = {
  parentClass: 'actions__menu',
};

export default ActionsMenuItem;
